"use client";

import {memo} from "react";

import {useKeenSlider} from "keen-slider/react";

import {Tag, TagBase} from "@/shared/ui/data-display/tags/tag-base";

import "keen-slider/keen-slider.min.css";

type BlogTagsSliderProps = {
    tags: ReadonlyArray<Tag>;
    onTagChange: (tag: string) => void;
};

export const BlogTagsSlider = memo(function BlogTagsSlider({tags, onTagChange}: BlogTagsSliderProps) {
    const [sliderRef] = useKeenSlider<HTMLDivElement>({
        slides: {
            perView: "auto",
            spacing: 4,
        },
        drag: true,
        loop: false,
        mode: "snap",
        rtl: false,
    });

    return (
        <div ref={sliderRef} className="popular-posts__tags keen-slider">
            {tags.map((tag, index) => (
                <div className="popular-posts__single-tag" key={`${tag}-${index}`}>
                    <TagBase key={tag.value} {...tag} onClick={(value) => onTagChange(value)} className="keen-slider__slide" />
                </div>
            ))}
        </div>
    );
});
